import React from 'react';
import ImageComponent from 'atoms/Image';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const QuotesComponent = ({ text }) => {
  return (
    <div className='quotes-section d-flex justify-content-center'>
      <div className='d-flex align-items-center'>
        <ImageComponent srcFile={IMAGE_PATH?.RightQuotes} />
        <ImageComponent srcFile={IMAGE_PATH?.RightQuotes} />
      </div>
      <span className='quote-desc text-center'>{text}</span>
      <div className='d-flex align-items-center'>
        <ImageComponent srcFile={IMAGE_PATH?.LeftQuotes} />
        <ImageComponent srcFile={IMAGE_PATH?.LeftQuotes} />
      </div>
    </div>
  );
};

export default QuotesComponent;
